export const PRIMARY_NAV_ITEMS = [
  { lngKey: 'layout.header.nav.dutyFreeShopping', path: '/duty-free-pre-order' },
  { lngKey: 'layout.header.nav.luggageDelivery', path: '/airport-luggage-delivery' },
  { lngKey: 'layout.header.nav.coupons', path: '/coupon' },
  { lngKey: 'layout.header.nav.vip', path: '/vip' },
] as const;
